module.exports = __webpack_public_path__ + "img/chelsea.4da27459.png";